export const dataReducer = (data = {}, action) => {
    switch (action.type) {
        case 'UPDATE_SECTION_SUCCESS':
            return {
                ...data,
                ...action.response.data
            };
        default:
            return data;
    }
};

const reducer = (state = {}, action) => {
    let newState;
    switch (action.type) {
        case 'CHANGE_PAGE_PARAMS_REQUEST':
            return {
                ...state,
                params: {
                    ...state.params,
                    [action.field]: action.value
                },
                paramsPending: {
                    ...state.paramsPending,
                    [action.field]: action.value
                }
            };
        case 'CHANGE_PAGE_PARAMS_SUCCESS':
            newState = {
                ...state,
                ...action.response
            };
            delete newState.paramsPending;
            return newState;
        case 'CHANGE_PAGE_PARAMS_FAILURE':
            return state; // TODO
        case 'CHANGE_PAGE_REQUEST':
            return state; // TODO pending object
        case 'CHANGE_PAGE_SUCCESS':
            return {
                ...state,
                ...action.response
            };
        case 'CHANGE_PAGE_FAILURE':
            return state; // TODO
        case 'UPDATE_SECTION_REQUEST':
            return state; // TODO pending object
        case 'UPDATE_SECTION_SUCCESS':
            return {
                ...state,
                data: dataReducer(state.data, action)
            };
        case 'UPDATE_SECTION_FAILURE':
            return state; // TODO
        case 'OPEN_COMPONENT':
            return {
                ...state,
                componentOpen: action.component
            };
        case 'CLOSE_COMPONENT':
            if (state.componentOpen) {
                return {
                    ...state,
                    componentOpen: null
                };
            }
            return state;

        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js